import numeral from 'numeral';

import { uuid } from '@/common/utils/uuid.utility';
import { type FeatureType } from '@/common/types/product-features.type';

interface CartesianUtilityParams {
  ids?: number[] | string[];
  baseArray: FeatureType[][];
  price: number[] | string[] | string | number;
  inStock: boolean[];
  discount?: number;
  mainPrice?: number;
}

export function Cartesian({
  ids,
  baseArray,
  price,
  inStock,
  discount,
  mainPrice,
}: CartesianUtilityParams) {
  const TotalPrice =
    (mainPrice ? numeral(mainPrice).value() ?? 0 : 0) *
    (discount ? (100 - discount) / 100 : 1);

  if (baseArray.length) {
    return baseArray
      .reduce((acc: any, curr: any) =>
        acc.flatMap((d: any) => curr.map((e: any) => [d, e].flat()))
      )
      .map((i: any, index: number) => {
        const id = ids && index < ids.length ? ids[index] : uuid();
        if (Array.isArray(i)) {
          return Object.assign(
            {
              id,
              price: Array.isArray(price)
                ? price[index] ?? numeral(TotalPrice).format('0,0')
                : price ?? numeral(TotalPrice).format('0,0'),
              inStock: inStock[index] !== undefined ? inStock[index] : true,
            },
            ...i.map((c) => ({ [c.type]: c.value }))
          );
        }
        return {
          id,
          price: Array.isArray(price)
            ? price[index] ?? numeral(TotalPrice).format('0,0')
            : price ?? numeral(TotalPrice).format('0,0'),
          inStock: inStock[index] !== undefined ? inStock[index] : true,
          [i.type]: i.value,
        };
      });
  }
  return [];
}
